import fetch from "auth/FetchInterceptor";
import { ApiConstant } from "constants/ApiConstant";

const MaintenanceService = {};

// These control endpoints are EXEMPT from the server's 503 maintenance response,
// so they return 200 even while maintenance is ON. The `x-maintenance-endpoint`
// header lets the axios interceptor know not to auto-dismiss the maintenance
// overlay just because one of these exempt calls succeeded.
const MAINTENANCE_ENDPOINT_HEADER = { "x-maintenance-endpoint": "1" };

// GET current maintenance state -> { enabled, message }
MaintenanceService.getState = function () {
  return fetch({
    url: ApiConstant.MAINTENANCE_STATE,
    method: "get",
    headers: { ...MAINTENANCE_ENDPOINT_HEADER },
  });
};

// POST new maintenance state, body { enabled, message } -> returns new state.
MaintenanceService.setState = function (data) {
  return fetch({
    url: ApiConstant.MAINTENANCE_STATE,
    method: "post",
    data,
    headers: { ...MAINTENANCE_ENDPOINT_HEADER },
  });
};

// GET the default maintenance message (used as the textarea placeholder).
MaintenanceService.getDefaultMessage = function () {
  return fetch({
    url: ApiConstant.MAINTENANCE_DEFAULT_MESSAGE,
    method: "get",
    headers: { ...MAINTENANCE_ENDPOINT_HEADER },
  });
};

export default MaintenanceService;
